/**
 * Google Analytics 4 utility module.
 * All gtag calls are guarded — if gtag is unavailable (blocked, missing ID),
 * every function is a silent no-op.
 */

const ROUTE_FEATURE_MAP = {
  '/': 'inventory',
  '/channels': 'channels',
  '/reports': 'reports',
  '/import-data': 'import_data',
  '/export-data': 'export_data',
  '/account': 'account',
  '/sales-transactions': 'sales_transactions',
  '/expenses': 'expenses',
  '/mileage': 'mileage',
  '/help': 'help',
  '/checkout-start': 'checkout_start',
  '/subscription-success': 'subscription_success',
  '/subscription-cancel': 'subscription_cancel',
  '/subscription-required': 'subscription_required',
  '/setup/channel': 'channel_setup',
};

const ROUTE_TITLES = {
  '/': 'Inventory',
  '/channels': 'Channels',
  '/reports': 'Reports',
  '/import-data': 'Import Data',
  '/export-data': 'Export Data',
  '/account': 'Account',
  '/sales-transactions': 'Sales Transactions',
  '/expenses': 'Expenses',
  '/mileage': 'Mileage',
  '/help': 'Help & Support',
  '/checkout-start': 'Checkout',
  '/subscription-success': 'Subscription Success',
  '/subscription-cancel': 'Subscription Cancel',
  '/subscription-required': 'Subscription Required',
  '/setup/channel': 'Channel Setup',
};

const FUNNEL_STEP_MAP = {
  checkout_start: 'begin_checkout',
  subscription_success: 'purchase',
  checkout_cancelled: 'checkout_cancelled',
  sign_up_complete: 'sign_up',
  onboarding_started: 'onboarding_started',
};

function isGtagAvailable() {
  return typeof window.gtag === 'function';
}

export function getPageTitle(pathname) {
  return ROUTE_TITLES[pathname] || 'Reseller Pro';
}

export function trackPageView(pagePath, pageTitle) {
  if (!isGtagAvailable()) return;
  window.gtag('event', 'page_view', {
    page_path: pagePath,
    page_title: pageTitle,
  });
}

export function trackEvent(eventName, params) {
  if (!isGtagAvailable()) return;
  window.gtag('event', eventName, params);
}

export function trackFunnelStep(stepName) {
  if (!isGtagAvailable()) return;
  const eventName = FUNNEL_STEP_MAP[stepName] || stepName;
  window.gtag('event', eventName, { funnel_step: stepName });
}

export function trackFeatureTransition(fromFeature, toFeature) {
  if (!isGtagAvailable()) return;
  window.gtag('event', 'feature_transition', {
    from_feature: fromFeature,
    to_feature: toFeature,
  });
}

export function trackFeatureDuration(featureName, durationSeconds) {
  if (!isGtagAvailable()) return;
  window.gtag('event', 'feature_view_duration', {
    feature_name: featureName,
    duration_seconds: durationSeconds,
  });
}

export { ROUTE_FEATURE_MAP };
